export const WIDGET_ID = 'FINAL_ONE_STANDING';
export const IFRAME_ID = 'final-one-standing';
export const IFRAME_SOURCE_ID = 'final-one-standing';
export const HOST_SOURCE_ID = 'william-hill';

export const CAS_URL = process.env.CAS_URL!;

export const IFRAME_SRC = process.env.IFRAME_SRC!;
export const IFRAME_CLOSE_TIMEOUT = 15000;
